import React from 'react';
import { IRouteGroup } from '../../../../interfaces';
import { Route } from '../Route';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { useRouteGroup, getFullHeightOfRouteGroup } from './lib';
import classNames from 'classnames';
import { useMainLayout } from '../../../../lib';
import './RouteGroup.scss';

interface RouteGroupProps {
    routeGroup: IRouteGroup;
}

export const RouteGroup: React.FC<RouteGroupProps> = (props) => {
    const { routeGroup } = props;

    const { currentPath } = useMainLayout();

    const { expanded, setExpandedHandler } = useRouteGroup({});

    if (routeGroup.routeGroups) {
        return (
            <div className='widget-main-layout-route-group'>
                <span
                    className='widget-main-layout-route-group__head-content'
                    onClick={setExpandedHandler}
                >
                    {routeGroup.name}
                    {expanded ? <BiChevronUp /> : <BiChevronDown />}
                </span>
                <div
                    className={classNames('widget-main-layout-route-group__expanded-content', { expanded })}
                    style={{
                        display: expanded ? 'block' : 'none',
                    }}
                >
                    {routeGroup.routeGroups.map((routeGroup) => {
                        return (
                            <RouteGroup
                                key={routeGroup.path + routeGroup.name}
                                routeGroup={routeGroup}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }

    if (routeGroup.routes) {
        return (
            <div className='widget-main-layout-route-group-nest'>
                <span
                    className={classNames('widget-main-layout-route-group-nest__head-content', {
                        active: currentPath?.includes(routeGroup.path) && !routeGroup.routes,
                    })}
                    onClick={setExpandedHandler}
                >
                    <div className={'widget-main-layout-route-group-nest__head-content__title'}>
                        {routeGroup.icon && (
                            <div className='widget-main-layout-route-group-nest__head-content__icon-block'>
                                <etna-icon
                                    color={'secondary'}
                                    size={'s'}
                                    name={routeGroup.icon}
                                />
                            </div>
                        )}
                        {routeGroup.name}
                    </div>
                    {!expanded ? <BiChevronUp /> : <BiChevronDown />}
                </span>
                <div
                    className={classNames('widget-main-layout-route-group-nest__expanded-content', {
                        expanded: !expanded,
                    })}
                    style={{
                        height: !expanded ? `${getFullHeightOfRouteGroup(routeGroup.routes?.length || 0)}px` : 0,
                    }}
                >
                    {routeGroup.routes.map((route) => {
                        return (
                            <div
                                key={route.path + route.name}
                                className='widget-main-layout-route-group-nest__expanded-content__nested-route'
                            >
                                <etna-icon
                                    color={'secondary'}
                                    size={'s'}
                                    name={'ArrowDiagonalUp'}
                                />
                                <Route route={route} />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    if (routeGroup.tabs) {
        return (
            <Route
                route={{
                    name: routeGroup.name,
                    tabs: routeGroup.tabs,
                    path: routeGroup.path,
                    icon: routeGroup.icon,
                }}
            />
        );
    }

    return <></>;
};
